/**
 * ──────────────────────────────────────────────────────────────
 * SINGLE SOURCE OF TRUTH for categories and brands.
 * Import from here everywhere — do NOT duplicate these lists.
 * ──────────────────────────────────────────────────────────────
 */

// ─── Categories ──────────────────────────────────────────────
export const CATEGORIES = [
  { _id: 1, title: "Home Care",           path: "home-care" },
  { _id: 2, title: "Personal Care",       path: "personal-care" },
  { _id: 3, title: "Kitchen Care",        path: "kitchen-care" },
  { _id: 4, title: "Kitchenware",         path: "kitchenware" },
  { _id: 5, title: "Cleaning Supplies",   path: "cleaning-supplies" },
  { _id: 6, title: "Automotive Accessories", path: "automotive-accessories" },
  { _id: 7, title: "Gift Items",          path: "gift-items" },
  { _id: 8, title: "Laundry Care",        path: "laundry-care" },
  { _id: 9, title: "Air Care",            path: "air-care" },
  { _id: 10, title: "Other",              path: "other" },
  { _id: 11, title: "Daraz Products",     path: "daraz-products" },
];

/** Category titles only — for simple dropdowns (e.g. Admin panel) */
export const CATEGORY_TITLES = CATEGORIES.map((c) => c.title);

// ─── Brands ──────────────────────────────────────────────────
export const BRANDS = [
  { _id: 900, title: "Leo Life" },
  { _id: 901, title: "Milano" },
  { _id: 902, title: "Feather" },
  { _id: 903, title: "Spotless" },
];

// ─── Navigation ──────────────────────────────────────────────
export const NAV_LINKS = [
  { _id: 1001, title: "Home",    link: "/" },
  { _id: 1002, title: "Shop",    link: "/shop" },
  { _id: 1003, title: "About",   link: "/about" },
  { _id: 1004, title: "Contact", link: "/contact" },
];
